import {
  inject,
  observer,
} from 'mobx-react';
import {
  toJS,
} from 'mobx'
import {
  WeaRadioGroup,
} from 'ecCom'

@inject('hrmApplicant')
@observer
export default class RadioGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.hrmApplicant.getRadioGroupDatas();
  }

  componentWillUnmount() {
    this.props.hrmApplicant.resetRadioGroup();
  }

  render() {
    const {
      hrmApplicant
    } = this.props, {
      radioGroup,
      radioGroupCallBack
    } = hrmApplicant, {
      config
    } = radioGroup;

    return (
      <div style={{padding: 16}}>
          {config.length > 0 && <WeaRadioGroup
              config={ config}
              onChange={params => radioGroupCallBack(params)}
          />}
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/applicant/RadioGroup.js